import { NavLink, useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';


const UserNavbar = ({ search = true }) => {

     const [value, setValue] = useState('')
     const [SearchParams, setSearchParams] = useSearchParams()
     const get_keyword = SearchParams.get('keyword')

     const handleSearch = (e) => {
          if (e.key === 'Enter') {
               setSearchParams({ keyword: value })
          }
     }

     useEffect(() => (
          setValue(get_keyword)
     ), [])


     return (
          <>
               <div className='row' style={{ margin: '0' }}>
                    <div className='col-12 searchTypeRow'>
                         <div className='topnav'>
                              <NavLink to={`/users/new`}>کاربر جدید</NavLink>
                              <NavLink to={`/users/management`}>مدیریت کاربران</NavLink>
                         </div>
                    </div>
               </div>

               {search && (
                    <div className='row' style={{ margin: '0', position: 'sticky', top: '0', zIndex: 999 }}>
                         <div className='col-md-12 searchTypeRow mobOrange'>
                              <div className='searchType'>
                                   <input type='text' placeholder='جستجوی کاربر...' defaultValue={value} onKeyUp={handleSearch} onChange={(e) => setValue(e.target.value)} />
                              </div>
                         </div>
                    </div>
               )}
          </>
     )
}
export default UserNavbar